export default __webpack_public_path__ + "static/media/bg-image.57fa06bc.jpg";